module.exports = __webpack_public_path__ + "img/activate-pdf-voucher-en.581533b7.png";